import React,{useEffect} from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PrivateLayout } from '../common/layouts';
import Loader from '@common/components/Loader';
import { loader } from '../store/features/loaderSlice';
import { loggedUser } from '../store/features/authSlice';
import { useDispatch } from 'react-redux';
import { setDispatcher, setNavigator } from '../../helpers';

const PrivateRoute = (props) => {
  const checkLoading = useSelector(loader);
  const checkLoggedInUser = useSelector(loggedUser);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdminLoggedIn = checkLoggedInUser.isAdminLoggedIn;
  window.addEventListener('storage', (e) => {
    if (e.isLogout !== undefined && e.isLogout !== '' && e.isLogout === 1) {
      navigate('/login');
    }
  });

    useEffect(() => {
      setNavigator(navigate);
      setDispatcher(dispatch);
    }, [navigate, dispatch]);

  return isAdminLoggedIn ? (
    <>
      {checkLoading ? <Loader /> : ''}
      <PrivateLayout>
        <Outlet />
      </PrivateLayout>
    </>
  ) : (
    <Navigate
      to={{
        pathname: '/login',
        state: { from: location }
      }}
    />
  );
};
export default PrivateRoute;
